export default __webpack_public_path__ + "static/media/complete-icon.ceb685da.svg";